import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8 col-12" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "demo-app-main" }
const _hoisted_4 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Two-Factor Authentication ")
const _hoisted_6 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_7 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 fs-6 fw-semibold pt-3 mb-3" }, " Two-factor authentication (2FA) adds an additional layer of protection beyond passwords. Downloading an authenticator app, like Google Authenticator or Authy, generates a time-based one-time password (TOTP) that changes every 30 seconds. You will need to enter this code to gain access to your account. ")
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Disable", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Enable", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _hoisted_5,
          (_ctx.user.google2fa_enabled)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "ON"))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "OFF"))
        ]),
        _hoisted_8,
        (!_ctx.user.mandatory_2fa)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.user.google2fa_enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: { name: 'otp-disable' },
                      class: "btn btn-danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: { name: 'otp-enable' },
                      class: "btn btn-success"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}